<template>
    <v-list-item
        v-if="!item?.hideInMenu"
        class="account-nav-item"
        :class="extraItemClass"
        :value="item.finalLink"
        :to="item.finalLink"
        :prepend-icon="icon"
        :density="slim ? 'compact' : 'default'"
        link
        exact
        rounded
        :slim="slim"
    >
        {{ item.title }}
    </v-list-item>
</template>

<script lang="ts" setup>
    import type { AccountNavItem } from '~/types';

    const props = defineProps<{
        item: AccountNavItem;
        extraItemClass?: Nilish<string>;
        hideIcon?: boolean;
        slim?: boolean;
    }>();

    const icon = computed(() => props.item.icon && !props.hideIcon ? props.item.icon : undefined);
</script>

<style lang="scss">
@use '~GlobalVars' as vars;

.account-nav-item {
    font-size: vars.$global-nav-item-font-size;
}
</style>
